<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { url } from '@/config/urls';
import { Capacitor } from '@capacitor/core';
import router from '@/router/index.js';
import { useTermsConsentStore } from '@stores/termsConsent';

const emit = defineEmits(['agreeOrderTerms']);

const store = useTermsConsentStore();
const isConsent = computed(() => store.orderTermsConsent);
const isNavigatingToPdf = ref(false);

const clickOrderTermsPdfLink = () => {
  store.setConsent('orderTerms');
  const platform = Capacitor.getPlatform();
  if (platform === 'ios' || platform === 'android') {
    isNavigatingToPdf.value = true;
    router.push({
      path: '/pdf-viewer/order-terms'
      , query: {
        reopenModal: 'orderTermsModal'
        , returnPath: router.currentRoute.value.path
      }
    });
  } else {
    // 同じウィンドウの新しいタブでPDF表示ページを開く
    window.open('/front/pdf-viewer/order-terms', '_blank', 'noopener');
  }
};

const agreeAndReset = () => {
  store.resetConsent('orderTerms');
  emit('agreeOrderTerms');
};

const onModalHidden = () => {
  if (isNavigatingToPdf.value) {
    isNavigatingToPdf.value = false;
    return;
  }
  store.resetConsent('orderTerms');
};

onMounted(() => {
  document.getElementById('orderTermsModal')?.addEventListener('hidden.bs.modal', onModalHidden);
});

onUnmounted(() => {
  document.getElementById('orderTermsModal')?.removeEventListener('hidden.bs.modal', onModalHidden);
});
</script>

<template>
  <div class="modal com_modal2 fade" id="orderTermsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1">ご確認ください</h3>
          <p class="com_fs14 com_center1">発注ルールの内容をご確認いただき、同意ボタンを押してください。</p>
          <p class="com_fs14 com_center1">
            <button type="button" class="btn com_link2" @click.prevent="clickOrderTermsPdfLink">発注ルールについて
              <img src="/front/assets/common/img/icon_pdf1.png" alt="" class="com_icon_pdf1">
            </button>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" data-bs-dismiss="modal" :disabled="!isConsent" @click="agreeAndReset">同意する</button>
          <button type="button" class="btn com_btn2" data-bs-dismiss="modal">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>